/* eslint-disable */
import ComplianceOverview from '@/components/probaworkflows_base_components/ComplianceOverview/ComplianceOverview.vue';
import ComplianceProfileTabs from '@/components/probaworkflows_base_components/ComplianceTabs/ComplianceProfileTabs.vue';
import CountSubEntities from '@/components/probaworkflows_base_components/CountSubEntities/CountSubEntities.vue';
import EntityComplianceAnswers from "@/components/probaworkflows_base_components/EntityComplianceAnswers/EntityComplianceAnswers.vue";
import FolderList from '@/components/probaworkflows_base_components/FolderList/FolderList.vue';
import OnboardingComplianceComponent from '@/components/probaworkflows_base_components/OnboardingComplianceChecklistComponent/OnboardingComplianceComponent.vue';
import OngoingComplianceComponent from '@/components/probaworkflows_base_components/OngoingComplianceComponent/OngoingComplianceForm.vue';
import RenderSections from '@/components/probaworkflows_base_components/RenderMainSections/RenderMainSections.vue';
import {
  ADMIN_VERIFY_APPLICATION_URL,
  APPROVED,
  ASSIGN_TRUST_ADMIN,
  COMPLIANCE_FORM,
  CREATE_ENTITY_APPLICATION_ONLY,
  ENTITY_REGISTER,
  GET_APPLICATION_FORMS,
  GET_ASSIGNED_WIDGETS,
  GET_ENTITY_TYPE_FORMS,
  get_headers,
  GET_MAIN_SECTIONS_VIEW,
  get_project_id,
  GET_USER_PROFILE_DETAILS_URL,
  GET_TABS,
  get_token,
  get_user_role,
  LIST_ASSIGNED_CHILD_ENTITY_TYPES_URL,
  NOT_APPROVED,
  ROLES_URL,
  USER_LIST_URLS,
  VIEW_FORM_STATUS,
} from '@/utils/constants/constants';
import alert_mixin from '@/utils/mixins/alert_mixin';
import formatting_mixins from '@/utils/mixins/formatting_mixins';
import { sub_entities_mixin } from '@/utils/mixins/sub_entities_mixins/sub_entities_mixin';
import { validate_email } from '@/utils/validations/validate_inputs';
import AssetsRegistry from '@/views/probaworkflows_base/Assets/AssetsRegistry/AssetsRegistry.vue';
import ESigning from '@/views/probaworkflows_base/management/template_managment/e_signing/ESigning.vue';
import ApplicationAttributes from '@/views/probaworkflows_base/management/trust_applications/application_attributes/ApplicationAttributes.vue';
import ApplicationJournal from '@/views/probaworkflows_base/management/trust_applications/application_journal/ApplicationJournal.vue';
import ApplicationVerification from '@/views/probaworkflows_base/management/trust_applications/application_verification/ApplicationVerification.vue';
import DocumentManagement from '@/views/probaworkflows_base/management/trust_applications/document_management/DocumentManagement.vue';
import ProgressTracker from '@/views/probaworkflows_base/management/trust_applications/progress_tracker/ProgressTracker.vue';
import VerificationOverview from '@/views/probaworkflows_base/management/trust_applications/verification_managment/verification_overview/VerificationOverview.vue';
import axios from 'axios';
import ViewRequests from '../view_requested_information/view_requests/ViewRequests.vue';
import CaseComplianceOverview from '@/components/probaworkflows_base_components/CaseComplianceOverview/CaseComplianceOverview.vue';

export default {
  name: 'OverviewOfProfile',
  mixins: [alert_mixin, formatting_mixins, sub_entities_mixin],
  components: {
    ProgressTracker,ApplicationVerification,
    VerificationOverview,ESigning,
    DocumentManagement,RenderSections,ViewRequests,
    ApplicationJournal,ApplicationAttributes,FolderList,
    OnboardingComplianceComponent,ComplianceProfileTabs,
    ComplianceOverview,OngoingComplianceComponent,CountSubEntities,
    AssetsRegistry,EntityComplianceAnswers,CaseComplianceOverview
  },
  data: () => ({
      entity_name: "",
      application_status: "",
      application_id: null,
      entity_profile_id: null,
      user_role: null,
      form_id: null,
      role_id: null,
      user_id: null,
      application_form_id: null,
      profile_role_id: null,
      active_tab: null,
      selected_dropdown: null,
      loading_more_tabs: false,
      token: get_token(),
      headers: get_headers(),
      entity_id: '',
      users: [],
      system_admins: [],
      users_list: [],
      user_roles: [],
      table_headers: [],
      error_message: '',
      assigned_admin: null,
      all_forms: [],
      assigned_tabs: [],
      form_tab_mapping: {},
      all_tabs: [],
      visible_tabs: [],
      dropdown_options: {},
      show_dropdown: false,
      selected_admin: '',
      temp_selected: '',
      tabs: [],
      compliance_main_sections: [],
      tabs_loading: false,
      tabs_error: null,
      database_tabs: [],
      active_form_main_section_id: null,
      status_approved: APPROVED,
      status_not_approved: NOT_APPROVED,
      status_list: [],
      current_status_id: null,
      pending_applications_list: [],
      LIST_SUB_ENTITIES_BY_PARENT_APPLICATION: 'LIST_SUB_ENTITIES_BY_PARENT_APPLICATION',
      is_verifying: false,
      current_entity: null,
      entity_type_id: null,
      is_loading_sub_entity: false,
      form_type: COMPLIANCE_FORM,
      current_form: {
        parent_id: null,
        parent_name: '',
        child_id: '',
        parent_application_id: '',
        parent_entity_profile_id: '',
      },
      assign_sub_entity_type_id: '',
      assign_sub_entity_options: [],
      assign_form_list: [],
      assign_selected_form_id: '',
      assign_entity_name: '',
      assign_email: '',
      include_email: false,
      project_id: null,
      is_saving: false,
      validation_error: null,
      is_loading_options: false,
      trust_number: "",
      force_reload: 0,
      openSections: {
        profile: true,
        onboarding: true,
        documents: true,
        compliance: false,
      },
      profile_user_details: {
        first_name: '',
        last_name: '',
        email: '',
        phone_number: '',
      },
      profile_sections: [],
      profile_documents: [],
      compliance_tabs: [
        { id: "caseoverview", name: "Case Overview" },
        { id: "overview", name: "Overview" },
        { id: "onboarding", name: "Onboarding Compliance" },
        { id: "ongoing", name: "Ongoing Compliance" },
      ],
      compliance_dropdown_options: {
        caseoverview: [{ value: "caseoverview", label: "Case Overview" }],
        onboarding: [{ value: "onboardingcompliance", label: "Onboarding Compliance" }],
        ongoing: [{ value: "ongoingcompliance", label: "Ongoing Compliance" }],
      },
      hasComplianceData: false,
      form_type: COMPLIANCE_FORM,
      child_entity_tab_map: {},
      document_reload_key: 0,
      hostname: window.location.hostname,
      has_mounted_overview: false,
      overview_reload_request: null,
  }),
  watch: {
  '$route.query': {
    immediate: true,
    deep: true,
    handler(newQuery, oldQuery) {
      const new_app_id = newQuery.application_id ? Number(newQuery.application_id) : null;
      const new_entity_profile_id = newQuery.entity_profile_id ? Number(newQuery.entity_profile_id) : null;
      const old_app_id = oldQuery?.application_id ? Number(oldQuery.application_id) : null;
      const old_entity_profile_id = oldQuery?.entity_profile_id ? Number(oldQuery.entity_profile_id) : null;

      if (!this.has_mounted_overview) {
        this.update_data_from_route();
        return;
      }

      if (new_app_id !== old_app_id || new_entity_profile_id !== old_entity_profile_id) {
        this.reload_component_data();
      } else {
        this.update_data_from_route();
      }
    }
  }
},
  computed: {
    flattened_main_sections() {
      // Flatten the array if it's nested
      return this.compliance_main_sections.flat();
    },
    forms_for_active_tab() {
      if (!this.active_tab || !this.all_forms) return [];
      const form_names = this.form_tab_mapping[this.active_tab] || [];
      return this.all_forms.filter(form => form_names.includes(form.name));
    },
    active_tab_has_forms() {
      return this.forms_for_active_tab?.length > 0;
    },
    active_tab_has_dropdown() {
      const tab = this.visible_tabs.find(t => t.id === this.active_tab);
      return tab?.has_dropdown || false;
    },
    active_tab_dropdown_options() {
      return this.dropdown_options[this.active_tab] || [];
    },
    active_tab_details() {
      return this.visible_tabs.find(tab => tab.id === this.active_tab) || {};
    },
    has_assigned_admin() {
      return this.assigned_admin !== null;
    },
    assigned_admin_name() {
      if (this.assigned_admin) {
        if (this.assigned_admin.full_name) {
          return this.assigned_admin.full_name;
        }
        return `${this.assigned_admin.first_name || ''} ${this.assigned_admin.last_name || ''}`.trim();
      }
      return '';
    },
    has_sub_entities() {
      return this.displayed_applications_list && this.displayed_applications_list.length > 0;
    },
    is_hierarchy_loading() {
      return this.is_hierarchy_loading;
    },
    get_entity_type_id() {
      const from_route = this.$route?.query?.entity_type_id ?? null;
      const value = from_route ?? sessionStorage.getItem('entity_type_id') ?? null;

      if (from_route != null) sessionStorage.setItem('entity_type_id', String(from_route));

      const num = Number(value);
      return Number.isFinite(num) ? num : (value ?? null);
    },
    is_master_registered() {
      return this.application_status.toLowerCase().includes('master registered');
    },

    display_trust_number() {
        return this.trust_number ||
               this.$route.query.trust_number ||
               sessionStorage.getItem('trust_number') ||
               '';
    },

    componentKey() {
      return `${this.application_id}-${this.entity_profile_id}-${this.force_reload}`;
    },

    visible_tabs_clean() {
      return (this.visible_tabs || []).filter(t => {
        const tab_text = `${t?.id || ''} ${t?.name || ''}`.toLowerCase();
        const is_profile_tab = tab_text.includes('profile');
        return !this.is_main_sections_placeholder(t) && !this.is_sub_entities_placeholder(t) && !is_profile_tab;
      });
    },

     orderedSections() {
      const sections = [
        { key: 'profile', label: 'Profile Information' },
        { key: 'onboarding', label: 'Onboarding Information' },
        { key: 'documents', label: 'Document Vault' },
        { key: 'compliance', label: 'Compliance Checks' },
      ];

      if (this.hasComplianceData) {
        return [
          sections.find(s => s.key === 'compliance'),
          sections.find(s => s.key === 'profile'),
          sections.find(s => s.key === 'onboarding'),
          sections.find(s => s.key === 'documents'),
        ];
      }

      return sections;
    },

    onboarding_description() {
      // Get all tab names except database tabs (forms) and child entity tabs
      const tabNames = this.getAvailableTabNames();
      const childEntityNames = this.getChildEntityNames();
      
      // Start with "Application forms" (for RenderMainSections)
      let description = "Z83 Application forms";
      
      // Add other feature names from tabs
      const features = [];
      
      // Check for specific features
      if (tabNames.some(name => name.includes("Verification"))) {
        features.push("verification");
      }
      if (tabNames.some(name => name.includes("E-Signing"))) {
        features.push("E-Signing");
      }
      if (tabNames.some(name => name.includes("Asset Registry"))) {
        features.push("Asset Registry");
      }
      if (tabNames.some(name => name.includes("Requests"))) {
        features.push("information requests");
      }
      if (tabNames.some(name => name.includes("Journal"))) {
        features.push("application journal");
      }
      if (tabNames.some(name => name.includes("Attributes"))) {
        features.push("attributes");
      }
      
      // Add child entity management
      if (childEntityNames.length > 0) {
        features.push(`${childEntityNames.join(", ")} management`);
      }
      
      // Add "sub-entities" if there are any child entities
      if (childEntityNames.length > 0) {
        features.push("sub-entities");
      }
      
      // Build the final description
      if (features.length > 0) {
        description += `, ${features.join(", ")}`;
      } else {
        description += ", verification, and sub-entities";
      }
      
      return description;
    },
  },
  methods: {
    get_tab_icon(tabId) {
    const icons = {
      personal_information: 'bi bi-person',
      contact_details: 'bi bi-telephone',
      employment: 'bi bi-briefcase',
      banking_information: 'bi bi-bank',
      'Verification': 'bi bi-shield-check',
      'Overview': 'bi bi-grid',
      attributes: 'bi bi-sliders',
      'Journal': 'bi bi-journal-text',
      'Requests': 'bi bi-inbox',
      'Asset Registry': 'bi bi-box-seam'
    }
 
    return icons[tabId] || 'bi bi-folder'
  },
    filterComplianceTabs() {
    // 1. Logic for x-verdict 
    if (this.hostname.includes('x-verdict')) {
      this.compliance_tabs = [
        { id: "onboarding", name: "Onboarding Compliance" },
      ];
      // Optionally remove the overview from dropdown options too
      // delete this.compliance_dropdown_options.overview;
    }
  },
    handleFilesSaved() {
      // Increment the key to force DocumentManagement to reload
      this.document_reload_key++;
    },

    is_profile_form_data(form_payload) {
      const form_type_name = form_payload?.form?.form_type?.form_type || '';
      return String(form_type_name).trim().toLowerCase() === 'profile form';
    },

    extract_profile_documents(sections = []) {
      return (sections || []).flatMap(section =>
        (section?.questions || [])
          .filter(question => question?.answer && typeof question.answer === 'object' && question.answer.presigned_url)
          .map(question => ({
            section_name: section?.name || 'Profile',
            question_text: question?.question_text || 'Document',
            file_name: question?.answer?.file_name || 'Document',
            presigned_url: question?.answer?.presigned_url,
          }))
      );
    },

    get_profile_user_identity_key(question_label) {
      const label = String(question_label || '').trim().toLowerCase();

      if (/^(first\s*name|given\s*name|name\s*of\s*applicant|name)$/.test(label)) {
        return 'first_name';
      }
      if (/^(last\s*name|surname|family\s*name)$/.test(label)) {
        return 'last_name';
      }
      if (/^(email|e-mail|email\s*address)$/.test(label)) {
        return 'email';
      }
      if (/^(phone|mobile|contact\s*number|telephone|cell\s*number|phone\s*number)$/.test(label)) {
        return 'phone_number';
      }

      return null;
    },

    get_synced_profile_user_value(question_label) {
      const key = this.get_profile_user_identity_key(question_label);
      if (!key) {
        return null;
      }

      return this.profile_user_details[key] || '';
    },

    sync_profile_sections_with_user_details(sections = []) {
      const synced_sections = (sections || []).map(section => ({
        ...section,
        questions: [...(section?.questions || [])],
      }));

      const seen_identity_keys = new Set();

      synced_sections.forEach(section => {
        section.questions = section.questions.map(question => {
          const identity_key = this.get_profile_user_identity_key(question?.question_text);
          if (!identity_key) {
            return question;
          }

          seen_identity_keys.add(identity_key);
          const synced_value = this.profile_user_details[identity_key] || '';

          if (!synced_value) {
            return question;
          }

          return {
            ...question,
            answer: synced_value,
          };
        });
      });

      const missing_identity_questions = [
        {
          key: 'first_name',
          section_question_id: 'user-first-name',
          question_text: 'First Name',
          answer: this.profile_user_details.first_name || '',
        },
        {
          key: 'last_name',
          section_question_id: 'user-last-name',
          question_text: 'Surname',
          answer: this.profile_user_details.last_name || '',
        },
        {
          key: 'email',
          section_question_id: 'user-email',
          question_text: 'Email Address',
          answer: this.profile_user_details.email || '',
        },
        {
          key: 'phone_number',
          section_question_id: 'user-phone',
          question_text: 'Phone Number',
          answer: this.profile_user_details.phone_number || '',
        },
      ].filter(item => item.answer && !seen_identity_keys.has(item.key));

      if (missing_identity_questions.length === 0) {
        return synced_sections;
      }

      if (synced_sections.length === 0) {
        return [
          {
            id: 'profile',
            name: 'Profile',
            questions: missing_identity_questions,
          },
        ];
      }

      synced_sections[0] = {
        ...synced_sections[0],
        questions: [...missing_identity_questions, ...(synced_sections[0]?.questions || [])],
      };

      return synced_sections;
    },

    async fetch_profile_user_details() {
      if (!this.entity_profile_id && !this.user_id) {
        this.profile_user_details = {
          first_name: '',
          last_name: '',
          email: '',
          phone_number: '',
        };
        return;
      }

      try {
        const response = await axios.get(GET_USER_PROFILE_DETAILS_URL, {
          headers: this.headers,
          params: {
            ...(this.entity_profile_id ? { entity_profile_id: this.entity_profile_id } : {}),
            ...(this.user_id ? { user_id: this.user_id } : {}),
          },
        });

        const user_data = response?.data?.data || {};
        this.profile_user_details = {
          first_name: user_data.first_name || '',
          last_name: user_data.last_name || '',
          email: user_data.email || '',
          phone_number: user_data.phone_number || '',
        };
      } catch (error) {
        this.profile_user_details = {
          first_name: '',
          last_name: '',
          email: '',
          phone_number: '',
        };
      }
    },

    async initialize_profile_information() {
      try {
        await this.fetch_profile_user_details();
        this.profile_sections = this.sync_profile_sections_with_user_details([]);
        this.profile_documents = this.extract_profile_documents(this.profile_sections);
      } catch (error) {
        this.profile_sections = this.sync_profile_sections_with_user_details([]);
        this.profile_documents = [];
      }
    },

    async fetch_profile_information() {
      try {
        if (!this.application_id) {
          this.profile_sections = this.sync_profile_sections_with_user_details([]);
          this.profile_documents = [];
          return;
        }

        const response = await axios.get(GET_APPLICATION_FORMS, {
          headers: this.headers,
          params: { application_id: this.application_id },
        });

        const forms = Array.isArray(response?.data?.data) ? response.data.data : [];
        const profile_form = forms.find(this.is_profile_form_data);
        this.profile_sections = this.sync_profile_sections_with_user_details(profile_form?.form?.sections || []);
        this.profile_documents = this.extract_profile_documents(this.profile_sections);
      } catch (error) {
        this.profile_sections = this.sync_profile_sections_with_user_details([]);
        this.profile_documents = [];
      }
    },

    getAvailableTabNames() {
      if (!this.visible_tabs || !Array.isArray(this.visible_tabs)) return [];
      
      return this.visible_tabs
        .filter(tab => {
          // Exclude database tabs (forms starting with 'ms-')
          if (this.is_db_main_section_tab(tab.id)) return false;
          // Exclude child entity tabs
          if (this.is_child_entity_type_tab(tab.id)) return false;
          return true;
        })
        .map(tab => tab.name || "")
        .filter(name => name.trim() !== "");
    },
  
    getChildEntityNames() {
      if (!this.child_entity_tab_map) return [];
      return Object.values(this.child_entity_tab_map)
        .map(item => item.name)
        .filter(name => name && name.trim() !== "");
    },
      
    // Update the inject_child_entity_type_tabs method to trigger description update
    async inject_child_entity_type_tabs() {
      const parent_entity_type_id = Number(
        this.$route?.query?.entity_type_id ??
        this.entity_type_id ??
        0
      );

      if (!parent_entity_type_id) return;

      // DB: pull assigned child entity types
      const rows = await this.get_assigned_children(parent_entity_type_id);

      // Build tabs from DB response (no hardcoding)
      const child_tabs = (rows || [])
        .map(r => {
          const id = Number(r.child_entity_type_id || 0);
          const name = String(r.child_entity_type_name || "Entity Type");
          return {
            id: `child-${id}`,                // tab id (string)
            name,
            has_dropdown: true,
            _child_entity_type_id: id,        // actual DB id
            _is_child_type_tab: true
          };
        })
        .filter(t => t._child_entity_type_id);

      // Remove any old "Sub-Entities" widget tab if it exists
      this.visible_tabs = (this.visible_tabs || []).filter(t => {
        const n = String(t.name || "").toLowerCase();
        const i = String(t.id || "").toLowerCase();
        return n !== "sub-entities" && i !== "sub-entities";
      });

      // Add child tabs to visible_tabs (choose placement)
      // Example: insert them right after "Overview" or after the first tab.
      const insert_index = 1;
      this.visible_tabs.splice(insert_index, 0, ...child_tabs);

      // Map for lookups
      this.child_entity_tab_map = {};
      child_tabs.forEach(t => {
        this.child_entity_tab_map[t.id] = { id: t._child_entity_type_id, name: t.name };
      });

      // Each child tab needs dropdown options so your accordion system can render it
      child_tabs.forEach(t => {
        this.dropdown_options[t.id] = [{ value: t.id, label: t.name }];
      });
      
      // Trigger computed property update
      this.$forceUpdate();
    },

    handleAssetCreated() {
      // Refresh the sub-entities hierarchy when an asset is created
      this.refresh_hierarchy()
    },
    /**
     * Toggle collapsible sections
     */
    toggleSection(sectionName) {
      this.openSections[sectionName] = !this.openSections[sectionName];
    },

    /**
     * Expand all sections
     */
    expandAllSections() {
      Object.keys(this.openSections).forEach(key => {
        this.openSections[key] = true;
      });
    },

    /**
     * Collapse all sections
     */
    collapseAllSections() {
      Object.keys(this.openSections).forEach(key => {
        this.openSections[key] = false;
      });
    },

    async inject_child_entity_type_tabs() {
      const parent_entity_type_id = Number(
        this.$route?.query?.entity_type_id ??
        this.entity_type_id ??
        0
      );

      if (!parent_entity_type_id) return;

      const rows = await this.get_assigned_children(parent_entity_type_id);

      const child_tabs = (rows || [])
        .map(r => {
          const id = Number(r.child_entity_type_id || 0);
          const name = String(r.child_entity_type_name || "Entity Type");
          return {
            id: `child-${id}`,
            name,
            has_dropdown: true,
            _child_entity_type_id: id,
            _is_child_type_tab: true,
          };
        })
        .filter(t => t._child_entity_type_id);

      this.visible_tabs = (this.visible_tabs || []).filter(t => !String(t?.id || "").startsWith("child-"));

      const sub_entities_index = (this.visible_tabs || []).findIndex(t => {
        const id = this.normalize_tab_key(t?.id);
        const name = this.normalize_tab_key(t?.name);
        return id === "sub_entities" || name === "sub_entities";
      });

      const insert_index = sub_entities_index !== -1 ? sub_entities_index : 1;
      this.visible_tabs.splice(insert_index, 0, ...child_tabs);

      this.visible_tabs = (this.visible_tabs || []).filter(t => {
        const id = this.normalize_tab_key(t?.id);
        const name = this.normalize_tab_key(t?.name);
        return !(id === "sub_entities" || name === "sub_entities");
      });

      this.child_entity_tab_map = {};
      child_tabs.forEach(t => {
        this.child_entity_tab_map[t.id] = { id: t._child_entity_type_id, name: t.name };
        this.dropdown_options[t.id] = [{ value: t.id, label: t.name }];
      });
    },


    is_sub_entities_placeholder(tab) {
      const id = this.normalize_tab_key(tab?.id);
      const name = this.normalize_tab_key(tab?.name);
      return id === "sub_entities" || name === "sub_entities";
    },


    is_child_entity_type_tab(val) {
      return typeof val === "string" && val.startsWith("child-");
    },

    child_type_id_from_tab(tab_id) {
      if (!this.is_child_entity_type_tab(tab_id)) return 0;
      return Number(String(tab_id).replace("child-", "")) || 0;
    },

    child_tab_title(tab_id) {
      return this.child_entity_tab_map?.[tab_id]?.name || "Sub-Entity";
    },

    child_tab_items(tab_id) {
      const child_type_id = this.child_type_id_from_tab(tab_id);
      if (!child_type_id) return [];

      // root entity is stored here by load_full_hierarchy()
      const root = Array.isArray(this.pending_applications_list)
        ? this.pending_applications_list[0]
        : null;

      const children = Array.isArray(root?.children) ? root.children : [];

      // children nodes already have entity_type_id from make_node_from_child_entity()
      return children.filter(c => Number(c.entity_type_id) === Number(child_type_id));
    },

    async ensure_root_children_loaded() {
      const root = Array.isArray(this.pending_applications_list)
        ? this.pending_applications_list[0]
        : null;

      if (!root) return;

      // If already loaded, do nothing
      if (root._children_loaded) return;

      const children = await this.get_sub_entities(this.application_id, this.entity_profile_id);

      root.children = (children || []).map(child =>
        this.make_node_from_child_entity(child, this.application_id)
      );

      root._children_loaded = true;
      root._children_checked = true;
      root.has_children = root.children.length > 0;

      // Refresh FolderList table state
      this.prep_tables();
    },

    normalize_tab_key(val) {
      return String(val || "")
        .toLowerCase()
        .trim()
        .replace(/\s+/g, "_")
        .replace(/-/g, "_");
    },


    is_main_sections_placeholder(tab) {
      // Covers both widget_name and widget_display_name possibilities
      const id = this.normalize_tab_key(tab?.id);
      const name = this.normalize_tab_key(tab?.name);

      return (
        id === "main_sections" ||
        name === "main_sections" ||
        id === "main_section" ||
        name === "main_section"
      );
    },




    async open_add_sub_entity_from_child_tab(tab_id) {
      // open modal with child type preselected
      const success = await this.prepare_assign_modal(this.current_entity);
      if (!success) return;

      const child_type_id = this.child_type_id_from_tab(tab_id);

      const exists = this.assign_sub_entity_options.some(
        opt => Number(opt.id) === Number(child_type_id)
      );

      if (exists) {
        this.assign_sub_entity_type_id = child_type_id;
        await this.assign_on_sub_entity_change();
      }

      this.$nextTick(() => {
        const modalElement = document.getElementById("assign_sub_entity_modal");
        if (!modalElement) return;
        new bootstrap.Modal(modalElement).show();
      });
    },



    handleComplianceLoaded(hasData) {
      this.hasComplianceData = hasData;

        // Auto-open & bring compliance forward visually
        if (hasData) {
          this.openSections.compliance = true;
          this.openSections.onboarding = false;
          this.openSections.documents = false;
        }
    },

    // Add this method to your methods section
    handleOngoingComplianceSubmitted(formData) {
      // You can add your submission logic here
      this.show_success('Ongoing compliance form submitted successfully!');

      // Optionally refresh compliance data
      this.get_compliance_form_main_sections();
    },

    async fetch_assigned_for_item(item) {
      // Call the mixin method
      await this.$options.mixins.find(m => m.methods && m.methods.fetch_assigned_for_item)
        .methods.fetch_assigned_for_item.call(this, item);
    },

    handle_status_updated(payload) {
        this.application_status = payload.formatted_status;
        sessionStorage.setItem('application_status', payload.status);
      this.update_current_status_id(payload.status);
        if (payload.trust_number) {
            this.trust_number = payload.trust_number;
            this.$router.replace({
                query: {
                    ...this.$route.query,
                    trust_number: payload.trust_number,
                    status: payload.status
                }
            });

            sessionStorage.setItem('trust_number', payload.trust_number);
        } else {
            this.$router.replace({
                query: {
                    ...this.$route.query,
                    status: payload.status
                }
            });
        }
    },

   normalize_item(item) {
      const is_child = Boolean(item?.is_child);
      return ({
        is_child,
        type_id: Number(
          item?.type_id ??
          item?.entity_type_id ??
          item?._child_raw?.entity_type_id ??
          0
        ),
        application_id: Number(
          item?.["Application No"] ??
          item?.application_id ??
          item?._child_raw?.forms?.[0]?.application_id ??
          0
        ),
        entity_profile_id: Number(
          is_child
            ? (item?.id ?? item?.entity_profile_id ?? 0)
            : (item?.entity_profile_id ?? item?.id ?? 0)
        ),
        entity_type_name:
          item?.["Entity Type"] ??
          item?.entity_type_name ??
          item?._child_raw?.entity_type_name ??
          "Entity"
      });
    },

    async prepare_assign_modal(item) {
      if (!item) {
        this.show_error('No entity selected. Please try again.');
        return false; // Return false to prevent modal opening
      }

      const normalize = this.normalize_item(item);
      if (!normalize.type_id || normalize.type_id === 0) {
        return false; // Prevent modal from opening
      }
      // Set current form data
      this.current_form.parent_id = normalize.type_id;
      this.current_form.parent_name = normalize.entity_type_name || "Entity";
      this.current_form.parent_application_id = normalize.application_id || this.application_id;
      this.current_form.parent_entity_profile_id = normalize.entity_profile_id || this.entity_profile_id;

      // Reset form fields
      this.assign_sub_entity_type_id = "";
      this.assign_form_list = [];
      this.assign_selected_form_id = "";
      this.assign_entity_name = "";
      this.assign_email = "";
      this.include_email = false;
      this.validation_error = null;
      this.is_saving = false;
      this.is_loading_options = true;

      try {
        // Load available sub-entity options
        const assigned_rows = await this.get_assigned_children(this.current_form.parent_id);
        this.assign_sub_entity_options = (assigned_rows || []).map(r => ({
          id: Number(r.child_entity_type_id),
          name: r.child_entity_type_name || "Unnamed",
        }));

        // Wait for Vue to update the DOM
        await this.$nextTick();
        // Return true to allow Bootstrap modal to open
        return true;

      } catch (error) {
        this.show_error('Failed to load sub-entity options: ' + error.message);
        return false; // Prevent modal from opening on error
      } finally {
        this.is_loading_options = false;
      }
    },

    handle_folderlist_add(item) {
      // Prepare the modal data first
      this.prepare_assign_modal(item).then(success => {
        if (!success) return;

        // After preparing data, manually trigger the modal
        this.$nextTick(() => {
          const modalElement = document.getElementById('assign_sub_entity_modal');
          if (!modalElement) return;

          new bootstrap.Modal(modalElement).show();
        });
      });
    },

    get_assigned_children(parent_entity_type_id) {
      if (!parent_entity_type_id || parent_entity_type_id === 0) return [];

      return axios.get(
        LIST_ASSIGNED_CHILD_ENTITY_TYPES_URL,
        {
          headers: this.headers,
          params: { parent_entity_type_id },
        }
      )
      .then(res => {
        if (res.data?.status !== 'success') return [];

        const payload = res.data?.data;
        const result = Array.isArray(payload)
          ? payload
          : payload?.assigned_children || [];

        return result;
      })
      .catch(error => {
        this.show_error('Error fetching assigned children:', error);
        return [];
      });
    },

    async assign_on_sub_entity_change() {
      this.assign_form_list = [];
      this.assign_selected_form_id = '';

      const entity_type_id = Number(this.assign_sub_entity_type_id || 0);
      if (!entity_type_id) {
        return;
      }

      try {
        const res = await axios.get(GET_ENTITY_TYPE_FORMS, {
          headers: this.headers,
          params: { entity_type_id }
        });

        const data = typeof res.data === 'string' ? JSON.parse(res.data) : res.data;
        this.assign_form_list = Array.isArray(data?.data) ? data.data : [];

      } catch (error) {
        this.show_error('Error getting forms:', error);
      }
    },

    async save_assign_sub_entity() {
      // Clear previous validation errors
      this.validation_error = null;
      this.is_saving = true;

      try {
        // Validation checks
        if (!this.current_form?.parent_application_id) {
          this.validation_error = "Missing parent application.";
        }

        const child_type_id = Number(this.assign_sub_entity_type_id || 0);
        if (!child_type_id) {
          this.validation_error = "Please select a sub-entity type.";
        }

        const selected_form_id = Number(this.assign_selected_form_id || 0);
        if (!selected_form_id) {
          this.validation_error = "Please select a form for the sub-entity.";
        }

        const entity_name = (this.assign_entity_name || "").trim();
        if (!entity_name) {
          this.validation_error = "Please enter the sub-entity name.";
        }

        let email = null;
        if (this.include_email) {
          email = (this.assign_email || "").trim();
          if (!email || !validate_email(email)) {
            this.validation_error = "Please enter a valid email address.";
          }
        }

        // Get project_id
        const project_id = get_project_id() || this.$route.params.project_id || this.$route.query.project_id;

        if (!project_id) {
          return;
        }

        // Prepare payload
        const payload = {
          parent_application_id: Number(this.current_form.parent_application_id),
          entity_type_id: child_type_id,
          parent_entity_type_id: Number(this.current_form.parent_id),
          parent_entity_profile_id: Number(this.current_form.parent_entity_profile_id),
          project_id: Number(project_id),
          form_ids: [selected_form_id],
          entity_name: entity_name,
          ...(this.include_email && { email }),
        };

        // Determine which API to use based on email inclusion
        const api_url = this.include_email ? ENTITY_REGISTER : CREATE_ENTITY_APPLICATION_ONLY;

        // Make API call
        const resp = await axios.post(api_url, payload, { headers: this.headers });

        let response_data;

        // Parse response based on API type
        if (this.include_email) {
          response_data = JSON.parse(resp.data);
        } else {
          response_data = resp.data;
        }

        if (response_data?.status !== "success") {
          const error_msg = response_data?.message || "Failed to assign sub-entity.";
          this.validation_error = error_msg;
        }

        // Success handling
        this.show_success("Sub-entity added successfully!");

        this.assign_sub_entity_type_id = "";
        this.assign_form_list = [];
        this.assign_selected_form_id = "";
        this.assign_entity_name = "";
        this.assign_email = "";
        this.include_email = false;
        this.validation_error = null;

        // Close modal using Bootstrap
        const modalElement = document.getElementById('assign_sub_entity_modal');
        if (modalElement) {
          const modal = bootstrap.Modal.getInstance(modalElement);
          if (modal) {
            modal.hide();
          }
        }

        await this.load_sub_entities();

      } catch (error) {
        const msg = error?.response?.data?.message || error.message ||
          "Error assigning the sub-entity.";
        this.validation_error = msg;
        this.show_error(msg);
      } finally {
        this.is_saving = false;
      }
    },

    // Other Methods (keep existing)
    update_data_from_route() {
      const query = this.$route.query;
      this.application_id = query.application_id ? Number(query.application_id) : null;
      this.entity_profile_id = query.entity_profile_id ? Number(query.entity_profile_id) : null;
      this.entity_type_id = query.entity_type_id ? Number(query.entity_type_id) : null;
      this.entity_name = query.entity_name || "";
      const raw_status = query.status || "";
      this.application_status = raw_status ? this.format_question_type(raw_status) : "";
      this.current_status_id = this.resolve_status_id(raw_status);
      this.current_entity = {
        type_id: this.entity_type_id,
        entity_type_name: this.entity_name,
        application_id: this.application_id,
        entity_profile_id: this.entity_profile_id,
        is_child: false
      };
      this.trust_number = query.trust_number || "";
    },

    async fetch_status_list() {
      try {
        if (typeof this.ensure_status_colors_loaded === 'function') {
          await this.ensure_status_colors_loaded();
        }

        const status_data = typeof this.get_global_status_definitions === 'function'
          ? this.get_global_status_definitions()
          : [];

        this.status_list = status_data.map((item) => ({
          id: Reflect.get(item, 'id'),
          raw_status: Reflect.get(item, 'status'),
          human_readable_status: this.format_question_type(Reflect.get(item, 'status')),
        }));
      } catch (error) {
        this.status_list = [];
      }
    },

    resolve_status_id(status_text) {
      if (!status_text || !Array.isArray(this.status_list) || this.status_list.length === 0) {
        return null;
      }

      const normalized = String(status_text).toLowerCase();
      const status_obj = this.status_list.find(item =>
        String(Reflect.get(item, 'raw_status') || '').toLowerCase() === normalized ||
        String(Reflect.get(item, 'human_readable_status') || '').toLowerCase() === normalized
      );

      return status_obj ? Reflect.get(status_obj, 'id') : null;
    },

    async update_current_status_id(status_text) {
      if (!status_text) {
        this.current_status_id = null;
        return;
      }

      if (!Array.isArray(this.status_list) || this.status_list.length === 0) {
        await this.fetch_status_list();
      }

      this.current_status_id = this.resolve_status_id(status_text);
    },

    redirect_to_application_overview(row) {
      this.show_loader("Loading sub-entity profile...")
        .then(async (loader) => {
          // Check if row is the new format with user_id in params
          const is_new_format = row && typeof row === 'object' &&
                            (row.application_id !== undefined || row['Application No'] !== undefined);

          let application_id, entity_profile_id, entity_type_id, entity_name, status, user_id;

          if (is_new_format) {
            // New format: row contains the params object from FolderList
            application_id = Number(row.application_id ?? row["Application No"] ?? row.id);
            entity_profile_id = row.entity_profile_id ?? row.entity ?? null;
            entity_type_id = row.entity_type_id ?? row.type_id ?? row.entity_type?.id ?? null;
            entity_name = row.entity_name ?? row["Entity Name"] ?? "Unknown Entity";
            status = row.status ?? row.Status ?? row.status?.status ?? "";
            user_id = row.user_id ?? this.user_id ?? null;
          } else {
            // Old format: row is the item object
            application_id = Number(row["Application No"] ?? row.application_id ?? row.id);
            entity_profile_id = row.entity_profile_id ?? row.entity ?? null;
            entity_type_id = row.entity_type_id ?? row.type_id ?? row.entity_type?.id ?? null;
            entity_name = row["Entity Name"] ?? row.entity_name ?? "Unknown Entity";
            status = row.Status ?? row.status?.status ?? row.status ?? "";

            // Try to extract user_id from row
            user_id = row["User ID"] ?? row.user_id ?? row.user_info?.id ??
                    (row.profile_role?.[0]?.user?.id) ?? (row.profile_role?.[0]?.user_id) ??
                    (row._child_raw?.user_id) ?? this.user_id ?? null;
          }

          if (!application_id) {
            this.show_error("Unable to find application data");
            this.close_loader(loader);
            return;
          }

          // Clear session storage
          sessionStorage.removeItem("application_id");
          sessionStorage.removeItem("application_status");
          sessionStorage.removeItem("entity_name");
          sessionStorage.removeItem("entity_profile_id");
          sessionStorage.removeItem("entity_type_id");
          sessionStorage.removeItem("user_id");

          // Set new values in session storage
          sessionStorage.setItem("application_id", application_id.toString());
          sessionStorage.setItem("application_status", status);
          sessionStorage.setItem("entity_name", entity_name);

          if (entity_profile_id != null) {
            sessionStorage.setItem("entity_profile_id", entity_profile_id.toString());
          }

          if (entity_type_id != null) {
            sessionStorage.setItem("entity_type_id", entity_type_id.toString());
          }

          if (user_id != null) {
            sessionStorage.setItem("user_id", user_id.toString());
          }

          // Build query parameters
          const query_params = {
            application_id: application_id.toString(),
            status: status,
            entity_name: entity_name,
            ...(entity_profile_id != null && { entity_profile_id: entity_profile_id.toString() }),
            ...(entity_type_id != null && { entity_type_id: entity_type_id.toString() }),
            ...(user_id != null && { user_id: user_id.toString() }),
          };

          // Use router.replace instead of router.push to avoid creating new history entries
          // This helps with component re-rendering
          await this.$router.replace({
            path: "/overview_of_profile",
            query: query_params,
          });
          this.close_loader(loader);

        })
        .catch(error => {
          this.show_error("Error loading sub-entity profile");
        });
    },


    async reload_component_data() {
      if (this.overview_reload_request) {
        return this.overview_reload_request;
      }

      this.overview_reload_request = (async () => {
      const loader = await this.show_loader("Loading application data...");

      try {
        // Clear existing data first
        this.clear_folder_list_data();
        this.pending_applications_list = [];
        this.displayed_applications_list = [];

        // Update from route
        this.update_data_from_route();

        this.force_reload++;

        await this.load_overview_core_data();

        // Reset tabs
        await this.inject_child_entity_type_tabs();
        this.initializeTabs();

        // Force Vue to re-render by updating a reactive property
        this.$forceUpdate();

      } catch (error) {
        this.show_error('Error loading application data: ' + error.message);
      } finally {
        this.close_loader(loader);
        this.warm_overview_supporting_data();
      }
      })();

      try {
        await this.overview_reload_request;
      } finally {
        this.overview_reload_request = null;
      }
    },

    async load_overview_core_data() {
      await Promise.all([
        this.fetch_status_list(),
        this.initialize_profile_information(),
        this.load_full_hierarchy(),
        (async () => {
          await this.fetch_assigned_widgets();
          await this.fetch_main_section_tabs();
        })(),
      ]);
    },

    warm_overview_supporting_data() {
      Promise.allSettled([
        this.fetch_profile_information(),
        this.fetch_users(),
        this.fetch_roles(),
      ]);
    },

    get_backend_filter_from_status(status) {
      const status_map = {
        'in-progress': 'In_Progress',
        'approved': 'Approved',
        'submitted': 'Submitted',
        'not approved': 'Not_Approved',
        'awaiting verification': 'Awaiting_Verification'
      };
      return status_map[status] || status;
    },

    open_assign_modal(item) {
      // For backward compatibility
      this.prepare_assign_modal(item).then(success => {
        if (success) {
          this.$nextTick(() => {
            const modalElement = document.getElementById('assign_sub_entity_modal');
            if (modalElement) {
              const modal = new bootstrap.Modal(modalElement);
              modal.show();
            }
          });
        }
      });
    },

    async load_sub_entities() {
      if (!this.application_id) return;

      try {
        await this.load_full_hierarchy();
      } catch (error) {
        this.show_error('Failed to load sub-entities');
      }
    },

    get_application_id() {
      const from_route = this.$route?.query?.application_id ?? null;
      const value = from_route ?? sessionStorage.getItem('application_id') ?? null;

      if (from_route != null) sessionStorage.setItem('application_id', String(from_route));

      const num = Number(value);
      return Number.isFinite(num) ? num : (value ?? null);
    },

    get_entity_profile_id() {
      const from_route = this.$route?.query?.entity_profile_id ?? null;
      const value = from_route ?? sessionStorage.getItem('entity_profile_id') ?? null;

      if (from_route != null) sessionStorage.setItem('entity_profile_id', String(from_route));

      const num = Number(value);
      return Number.isFinite(num) ? num : (value ?? null);
    },

    is_db_main_section_tab(tabId) {
      return typeof tabId === 'string' && tabId.startsWith('ms-');
    },

    fetch_assigned_widgets() {          
        const request_params = {};
        
        // Check if we're viewing a child entity tab
        const is_child_entity_tab = '';
        
        if (is_child_entity_tab) {
          // For child entity tabs, extract entity_type_id from child items
          const child_items = this.child_tab_items(this.selected_dropdown);
          
          if (child_items && child_items.length > 0) {
            // Try to get entity_type_id from the first child item
            const first_child = child_items[0];
            
            // Check multiple possible sources for entity_type_id
            const entity_type_id = 
              first_child.entity_type_id || 
              first_child.type_id ||
              (first_child._child_raw && first_child._child_raw.entity_type_id);
            
            if (entity_type_id) {
              request_params.entity_type_id = entity_type_id;
            } else {
              // If we can't find entity_type_id, use entity_profile_id of the first child
              const child_entity_profile_id = first_child.id || first_child.entity_profile_id;
              if (child_entity_profile_id) {
                request_params.entity_profile_id = child_entity_profile_id;
              }
            }
          }
        } else {
          // For main entity, use entity_profile_id
          request_params.entity_profile_id = this.entity_profile_id;
        }

        // Always include role_id if available
        if (this.user_role_id) {
          request_params.role_id = this.user_role_id;
        }

        return axios
          .get(GET_ASSIGNED_WIDGETS, {
            params: request_params,
            headers: this.headers,
          })
          .then(({ data }) => {
            const tabs = (data || []).map(item => ({
              id: item.widget.widget_name,
              name: item.widget.widget_display_name,
              has_dropdown: true,
              _is_widget_tab: true,
            }));

            this.all_tabs = tabs;

            this.dropdown_options = Object.fromEntries(
              tabs.map(t => [
                t.id,
                [{ value: t.id, label: t.name }]
              ])
            );

            this.assigned_tabs = [...tabs];
            this.visible_tabs = [...tabs];

            this.$forceUpdate();
          })
          .catch(error => {
            const message =
              error?.response?.data?.message ||
              error.message ||
              "Failed to load widgets";
            this.show_error(message);
          });
    },

    fetch_main_section_tabs() {
      const request_params = {
        application_id: this.application_id,
        entity_profile_id: this.entity_profile_id,
      };

      return axios
        .get(GET_TABS, { params: request_params, headers: this.headers })
        .then(({ data }) => {
          this.application_form_id = data.data.application_form_id;
          if (this.application_form_id != null) {
            sessionStorage.setItem('application_form_id', String(this.application_form_id));
          }

          const rows = Array.isArray(data?.data?.data) ? data.data.data : [];

          const dynamic_tabs = rows.map(row => ({
            id: `ms-${row.id}`,
            name: row.name,
            has_dropdown: true,
            form_main_section_id: row.id,
            _is_main_section_tab: true,
          }));

          this.database_tabs = dynamic_tabs;

          if (!Array.isArray(this.visible_tabs)) this.visible_tabs = [];
          if (typeof this.dropdown_options !== "object" || this.dropdown_options === null) {
            this.dropdown_options = {};
          }

          dynamic_tabs.forEach(tab => {
            const options = [{ value: tab.id, label: tab.name }];
            if (this.$set) this.$set(this.dropdown_options, tab.id, options);
            else this.dropdown_options[tab.id] = options;
          });

          const placeholder_index = this.visible_tabs.findIndex(t =>
            this.is_main_sections_placeholder(t)
          );

          if (placeholder_index !== -1) {
            this.visible_tabs.splice(placeholder_index, 1, ...dynamic_tabs);
          } else {
            const insert_after_index = this.visible_tabs.findIndex(
              tab => tab.id === "application_data"
            );

            if (insert_after_index !== -1) {
              this.visible_tabs.splice(insert_after_index + 1, 0, ...dynamic_tabs);
            } else {
              this.visible_tabs.push(...dynamic_tabs);
            }
          }

          this.visible_tabs = this.visible_tabs.filter(t => !this.is_main_sections_placeholder(t));
        })
        .catch(error => {
          const message =
            error?.response?.data?.message ||
            error.message ||
            "Failed to load tabs";
          this.show_error(message);
        });
    },


    select_admin(admin_name) {
      this.temp_selected = admin_name;
      this.assign_trust_admin();
    },

    get_form_dropdown_value() {
      const mapping = {
        'trust_information': 'trust information',
      };
      return mapping[this.active_tab];
    },

    initializeTabs() {
      const storage_key = `active_tab_${this.application_id}`;
      const saved_tab = localStorage.getItem(storage_key);

      const saved_is_placeholder =
        this.is_main_sections_placeholder({ id: saved_tab, name: saved_tab }) ||
        this.is_sub_entities_placeholder({ id: saved_tab, name: saved_tab });

      if (!saved_tab || saved_is_placeholder) {
        const first = (this.visible_tabs_clean?.[0]?.id) || (this.visible_tabs?.[0]?.id);
        if (first) this.select_tab(first);
        return;
      }

      this.select_tab(saved_tab);
    },



    dropdown_forms_id(val) {
      if (!this.is_db_main_section_tab(val)) return null;
      const num = Number(String(val).slice(3));
      return Number.isFinite(num) ? num : null;
    },

    select_tab(tab_id) {
      this.active_tab = tab_id;

      const storage_key = `active_tab_${this.application_id}`;
      localStorage.setItem(storage_key, tab_id);

      if (this.is_child_entity_type_tab(tab_id)) {
        this.selected_dropdown = tab_id;
        this.ensure_root_children_loaded();
        return;
      }

      if (this.is_db_main_section_tab(tab_id)) {
        if (!this.dropdown_options[tab_id]) {
          this.dropdown_options[tab_id] = [{ value: tab_id, label: this.get_db_tab_label(tab_id) }];
        }

        this.selected_dropdown = tab_id;
        this.active_form_main_section_id = this.dropdown_forms_id(tab_id);
        return;
      }

      const forms_dropdown_value = this.get_form_dropdown_value();
      if (forms_dropdown_value) {
        this.selected_dropdown = forms_dropdown_value;
      } else if (this.active_tab_has_dropdown) {
        const options = this.dropdown_options[tab_id];
        this.selected_dropdown = options?.[0]?.value || null;
      } else {
        this.selected_dropdown = null;
      }

      this.active_form_main_section_id = null;
    },

    admin_verify(status) {
      const data = {
        application_id: parseInt(this.application_id, 10),
        status: status
      };

      axios.post(ADMIN_VERIFY_APPLICATION_URL, data, {
        headers: this.headers
      })
        .then(response => {
          const response_data = response.data;

          if (response_data.status === 'success') {
            sessionStorage.setItem('application_status', response_data.data)
            this.application_status = this.format_question_type(response_data.data)
            this.get_form_to_preview();
            this.show_success("Admin verified successfully.")
          } else {
            this.show_error('Error during the admin verification');
          }
        })
        .catch(error => {
          if (error.response && error.response.data) {
            this.show_error(error.response.data.message);
          }
        });
      this.show_success('Answers approved successfully');
    },

    get_db_tab_label(tab_id) {
      const tab =
        (Array.isArray(this.visible_tabs) ? this.visible_tabs : []).find(t => t.id === tab_id) ||
        (Array.isArray(this.database_tabs) ? this.database_tabs : []).find(t => t.id === tab_id);

      if (tab?.name) return tab.name;
      const id_num = this.dropdown_forms_id(tab_id);
      return id_num != null ? `Section ${id_num}` : 'Section';
    },

    clear_admin_data() {
      this.assigned_admin = null;
      this.selected_admin = '';
      this.temp_selected = '';
    },

    async assign_trust_admin() {
      const selected_admin_obj = this.users.find(
        user => `${user.first_name} ${user.last_name}` === this.temp_selected
      );

      if (!selected_admin_obj) {
        const error = new Error('Selected admin not found');
        this.show_error(error);
      }

      const payload = {
        application_id: Number(this.application_id),
        user_id: Number(selected_admin_obj.user_id),
        assign_as_administrator: true
      };

      return axios.post(ASSIGN_TRUST_ADMIN, payload, {
        headers: this.headers
      })
        .then(async (response) => {
          if (response.data.status === 'success') {
            this.selected_admin = this.temp_selected;
            this.show_dropdown = false;

            this.show_success(response.data.message || 'Admin assigned successfully');
            return response.data;
          } else {
            const error = new Error(response.data.message || 'Failed to assign admin');
            this.show_error(error);
          }
        })
        .catch((error) => {
          this.show_error(error.response?.data?.message || error.message || 'Failed to assign admin');
        });
    },

    assign_admin() {
      this.assign_trust_admin();
    },

    toggle_dropdown(value) {
      this.selected_dropdown = this.selected_dropdown === value ? '' : value;
    },

    async fetch_users() {
      this.error_message = '';
      try {
        const response = await axios.get(USER_LIST_URLS, {
          headers: this.headers,
          params: { project_id: this.project_id }
        });

        const res = JSON.parse(response.data);

        this.users = res.data.map(user => ({
          user_id: user.user_id,
          first_name: user.user.first_name,
          last_name: user.user.last_name,
          name: (user.user.first_name && user.user.last_name)
            ? `${user.user.first_name} ${user.user.last_name}`
            : "User has not logged in",
          email: user.user.email,
          phone_number: user.phone_number || '',
          last_login: user.user?.last_login ?? "Never logged in",
          role: user.user.role.role === "Entity" ? "Founder" : user.user.role.role,
          is_active: user.is_active,
          rawRole: user.user.role.role
        }));

        this.system_admins = this.users
          .filter(user => user.rawRole === "System Admin")
          .map(admin => admin.name);

        this.users_list = this.users;
        this.table_headers = Object.keys(this.users_list[0]);
      } catch (error) {
        this.error_message = 'Error fetching users: ' + error.message;
        this.show_error(this.error_message);
      }
    },

    async fetch_roles() {
      const response = await axios.get(ROLES_URL, {
        headers: this.headers,
      });
      this.user_roles = response.data.data;
    },

    get_compliance_form_main_sections() {
      const params = {
        entity_type_id: this.entity_type_id,
        form_id: this.form_id,
        form_type: this.form_type || COMPLIANCE_FORM,
      }

      axios.get(GET_MAIN_SECTIONS_VIEW, { params: params, headers: this.headers })
        .then(response => {
          this.compliance_main_sections = [response.data.data]
        })
        .catch(() => {
          this.show_error("Unable to retrieve Compliance Sections")
        })
    },

    handle_verification_start() {
      this.is_verifying = true;
      setTimeout(() => {
        this.is_verifying = false;
        this.show_success('Verification completed successfully');
      }, 3000);
    },

    handle_error(error) {
      this.is_verifying = false;
      this.show_error('Verification failed: ' + error.message);
    },

    redirect_to_assignments() {
      this.$router.push({
        path: "/application_assignment",
      });
    },

  },
  created() {
    this.headers = get_headers();
    this.filterComplianceTabs();

    const storage_key = `active_tab_${this.application_id}`;
    const saved_tab = localStorage.getItem(storage_key);

    if (saved_tab) {
      this.active_tab = saved_tab;
    } else if (this.visible_tabs.length > 0) {
      this.active_tab = this.visible_tabs[0].id;
    }

    this.project_id = get_project_id()
    this.update_data_from_route();
    const query = this.$route.query;
    this.form_id = query.form_id || null;
    this.role_id = query.role_id || null;
    this.profile_role_id = query.profile_role_form_id || null;
    this.user_id = query.user_id;
  },
  async mounted() {
    const loader = await this.show_loader("Loading application overview...");

    try {
      this.user_role = get_user_role();
      const storage_key = `active_tab_${this.application_id}`;
      const saved_tab = localStorage.getItem(storage_key);
      await this.load_overview_core_data();
      this.update_current_status_id(this.$route.query.status || this.application_status);
      await this.inject_child_entity_type_tabs();

      if (this.visible_tabs.length > 0) {
        if (saved_tab === null || saved_tab === undefined) {
          this.select_tab(this.visible_tabs[0].id);
        } else {
          this.select_tab(saved_tab);
        }
      }
    } catch (error) {
      this.show_error('Error loading application data: ' + error.message);
    } finally {
      this.has_mounted_overview = true;
      this.close_loader(loader);
      this.warm_overview_supporting_data();
    }
  },

  beforeDestroy() {
    // Clean up modal event listeners if any
    const modalElement = document.getElementById('assign_sub_entity_modal');
    if (modalElement) {
      const modal = bootstrap.Modal.getInstance(modalElement);
      if (modal) {
        modal.dispose();
      }
    }
  }
};
